import { render, staticRenderFns } from "./VideoGallery.vue?vue&type=template&id=4aa752fe&scoped=true&"
import script from "./VideoGallery.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VideoGallery.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./VideoGallery.vue?vue&type=style&index=0&id=4aa752fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa752fe",
  null
  
)

export default component.exports